export enum QueryKeyType {
	SINGLE_TICKET = 'getSingle',
	ALL_TICKETS = 'getTickets',
	UNREAD_COUNT = 'getUnread',
	SEND_MESSAGE = 'sendMessage',
	CREATE_TICKET = 'createTicket',
	SEND_SURVEY = 'sendSurvey',
}
